/** The AI models admin routes (SA-1087 spec §9; SA-1103 adds the model list). The words a
 * refusal reads as live in the page's `aiModelsText.ts`, which imports this file. */
import { apiClient } from './apiClient'
import type { AiModelFunction, AiModelList, AiModelTestResult, AiModelWrite, AiModelsRead } from '@/types/aiModels'

const BASE = '/api/admin/ai-models'
const one = (id: string) => `${BASE}/${encodeURIComponent(id)}`

export function listAiModels(): Promise<AiModelsRead> {
  return apiClient.get<AiModelsRead>(BASE)
}

export function saveAiModel(id: string, body: AiModelWrite): Promise<AiModelFunction> {
  return apiClient.put<AiModelFunction>(one(id), body)
}

export function testAiModel(id: string, body: AiModelWrite): Promise<AiModelTestResult> {
  return apiClient.post<AiModelTestResult>(`${one(id)}/test`, body)
}

export function listProviderModels(id: string, body: AiModelWrite): Promise<AiModelList> {
  return apiClient.post<AiModelList>(`${one(id)}/models`, body)
}

export function clearAiModel(id: string): Promise<void> {
  return apiClient.delete(one(id))
}
